import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { totpService } from '../../../../services/totpService';
import ConfirmationModal from '../../../../components/ui/ConfirmationModal/ConfirmationModal.jsx';

const TOTPDisableModal = ({ onSuccess, onCancel, onError }) => {
  const { t } = useTranslation(['profile', 'common']);
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleDisable = async () => {
    if (!password.trim()) {
      setError(t('profile:totp.password_required'));
      return;
    }

    try {
      setLoading(true);
      setError('');
      
      await totpService.disable(password);
      onSuccess();
    } catch (error) {
      console.error('TOTP disable error:', error);
      const errorMessage = error.response?.data?.message || t('profile:totp.disable_failed');
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    if (error) {
      setError(''); // Clear error when user starts typing
    }
  };

  return (
    <ConfirmationModal
      isOpen={true}
      onConfirm={handleDisable}
      onCancel={onCancel}
      title={t('profile:totp.disable_title')}
      message={t('profile:totp.disable_confirmation')}
      confirmText={loading ? t('profile:totp.disabling') : t('profile:totp.disable_button')}
      cancelText={t('common:buttons.cancel')}
      type="danger"
      loading={loading}
    >
      <div className="totp-disable-form">
        <div className="form-group">
          <label htmlFor="password" className="form-label">
            {t('common:labels.password')}:
          </label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={handlePasswordChange}
            className="form-input"
            placeholder={t('profile:totp.password_placeholder')}
            disabled={loading}
            autoFocus
          />
        </div>

        {error && (
          <div className="error-message">
            {error}
          </div>
        )}

        <div className="warning-message">
          <div className="warning-icon">⚠️</div>
          <div className="warning-text">
            <strong>{t('profile:totp.disable_warning_title')}</strong>
            <p>{t('profile:totp.disable_warning_text')}</p>
          </div>
        </div>
      </div>
    </ConfirmationModal>
  );
};

export default TOTPDisableModal;